import gql from 'graphql-tag'

export default gql`query system_setting($id: Int!){
  system_setting(id: $id){
    id
    description
    setting_type_id
    setting_value
  }
}`